import { LitElement, html, css } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

// !!! Usage of UNSAFE HTML !!!
// This is not the ideal way to handle this, the web component _should_ take
// the data and format it into the correct HTML, however until we refactor
// the entire PDP to use Web Components it is more efficient to keep the HTML
// generation in one place (the backend .tpl files) and pass it into the
// web component for consistency

class CbomPricingSection extends LitElement {
  // Properties
  static properties = {
    stock: { type: Boolean },
    stockMessage: { type: String },
    preDiscountedPrice: { type: String },
    price: { type: String },
    priceTax: { type: String },
    deliveryExpectation: { type: String },
    layout: { type: String },
  };

  connectedCallback() {
    super.connectedCallback();
    this.boundHandleProductUpdate = this.handleProductUpdate.bind(this);
    addEventListener('cbomproductupdate', this.boundHandleProductUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    removeEventListener('cbomproductupdate', this.boundHandleProductUpdate);
  }

  static styles = css`
    :host {
      display: -ms-grid;
      display: grid;
      -ms-grid-columns: [price] auto [prediscountedprice] auto [tax] 1fr;
      grid-template-columns: [price] auto [prediscountedprice] auto [tax] 1fr;
      font-family: Arial, Helvetica, sans-serif;
    }
    .price-original {
      -ms-flex-order: 2;
      order: 2;
      text-decoration: line-through;
      color: #434649;
      font-size: 20px;
      margin-left: 24px;
    }
    :host([layout='minimal']) .price-original {
      margin-left: 0px;
      line-height: 20px;
    }
    .price {
      -ms-flex-order: 1;
      order: 1;
      color: #d00000;
      font-size: 30px;
      font-weight: bold;
      line-height: 0.9;
    }
    .tax {
      -ms-flex-order: 3;
      order: 3;
      color: #83888b;
      font-size: 12px;
      text-align: right;
    }
    .stock {
      -ms-flex-order: 4;
      order: 4;
      grid-column-start: span 3;
      font-size: 18px;
      font-weight: bold;
      line-height: 27px;
    }
    .stock.in {
      color: #009f51;
    }
    .stock.out {
      color: #434649;
      font-size: 15px;
    }
    .delivery-information {
      -ms-flex-order: 5;
      order: 5;
      grid-column-start: span 3;
      color: #434649;
      margin: 0;
      font-size: 15px;
      line-height: 1.5em;
    }
    :host([layout='minimal']) {
      padding: 10px;
      display: block;
    }
    :host([layout='minimal']) {
      padding: 10px;
      display: block;
    }
    :host([layout='minimal']) .price {
      line-height: 1;
    }
    :host([layout='pdp-bottom']) {
      -ms-grid-columns: [price] 2fr [prediscountedprice] 1fr [tax] 1fr;
      grid-template-columns: [price] 2fr [prediscountedprice] 1fr [tax] 1fr;
    }
    :host([layout='pdp-bottom']) .price {
      grid-column-start: 3;
      text-align: right;
    }
    :host([layout='pdp-bottom']) .tax {
      grid-column-start: span 3;
      text-align: right;
      line-height: 2;
    }
    :host([layout='pdp-bottom']) .stock {
      -ms-flex-order: 1;
      order: 1;
      grid-column-start: 1;
      grid-row-start: 1;
    }
    :host([layout='pdp-bottom']) .price-original {
      -ms-flex-order: 2;
      order: 2;
      grid-column-start: 2;
      grid-row-start: 1;
      padding: 0;
      display: flex;
      align-items: center;
      margin-right: 30px;
    }

    .tooltip-target {
      display: none;
    }
    .delivery-estimate-date,
    .dlv-get-tomorrow,
    .delivery-advice-date {
      font-weight: 700;
    }
    .price-original,
    .price,
    :host([layout='pdp-bottom']) .stock {
      align-self: end;
    }
    .price-original,
    :host([layout='pdp-bottom']) .stock {
      line-height: 1;
    }

    .price-original,
    .info-row-price {
      white-space: nowrap;
    }
  `;

  // Render
  render() {
    if (this.layout === 'minimal') {
      return this.renderMinimal();
    }

    return html`
      <div class="price-original">${unsafeHTML(this.preDiscountedPrice)}</div>
      <div class="price">${unsafeHTML(this.price)}</div>
      <div class="tax">${unsafeHTML(this.priceTax)}</div>
      <div class="stock${' ' + (this.stock ? 'in' : 'out')}">
        ${this.stockMessage}
      </div>
      <div class="delivery-information">
        ${unsafeHTML(this.deliveryExpectation)}
      </div>
    `;
  }

  renderMinimal() {
    return html`<div class="price-original">
        ${unsafeHTML(this.preDiscountedPrice)}
      </div>
      <div class="price">${unsafeHTML(this.price)}</div>`;
  }

  // Update
  handleProductUpdate(event) {
    // Set new data
    this.price = event.detail.price;
    this.preDiscountedPrice = event.detail.preDiscountedPrice;
    this.stock = event.detail.stock;
    this.stockMessage = event.detail.stockMessage;
    this.deliveryExpectation = event.detail.deliveryExpectation;

    // Rerender the relevant components to reflect the property changes
    this.requestUpdate();
  }
}

customElements.define('cbom-pricing-section', CbomPricingSection);
